import 'regenerator-runtime/runtime';
import { all } from 'redux-saga/effects';
import { watchStateSnapshot } from './stateSnapshotSaga';
import { watchStreckeSnapshot } from './streckeSnapshotSaga';
import { watchInDashboardUebernehmenSaga } from './inDashboardUebernehmenSaga';
import { streckenTarifierungJHP } from './streckenTarifierungJHP';
import { watchAntragsnummerRequested } from './antragsnummerSaga';
import { watchVorschlagdatenChanged } from './vorschlagdatenSaga';
import { shopTarifierungJHP } from './shopTarifierungJHP';
import { watchDruckdatenChanged } from './druckdatenSaga';
import { watchVorbelegungRequested } from './vorbelegungSaga';
import { handleJhpNavigationToAngebotSaga } from './handleJhpNavigationToAngebotSaga';

export function* rootSaga() {
  yield all([
    watchStateSnapshot(),
    watchStreckeSnapshot(),
    watchInDashboardUebernehmenSaga(),
    watchAntragsnummerRequested(),
    watchVorschlagdatenChanged(),
    streckenTarifierungJHP(),
    shopTarifierungJHP(),
    watchDruckdatenChanged(),
    watchVorbelegungRequested(),
    handleJhpNavigationToAngebotSaga(),
  ]);
}
